import { request } from '@/utils/request'

// get
export const reqDriverInfo = (phone) =>
  request.get(`driver/info?account=${phone}`)

export const reqDriverStatus = (phone) => request.get(`status?account=${phone}`)

export const reqPushMsg = (id) =>
  request.get(`pushMessage?id=${id}&message=提醒:${id}單，乘客已取消`)

export const reqNonFinishBill = (kw, npp, page) =>
  request.get(`bill/nonFinishBill/?kw=${kw}&npp=${npp}&page=${page}`)

export const reqTransList = (kw, npp, page, task) =>
  request.get(
    `service/transaction?kw=${kw}&npp=${npp}&page=${page}&task=${task}`,
  )

export const reqNonReply = () =>
  request.get('reservation/list/?npp=0&page=1&task=nonAssign')

export const reqReserveList = (page) =>
  request.get(`reservation/v2?current_page=${page}&per_page=10`)

export const reqMsgList = (npp, page) =>
  request.get(`message/list/?npp=${npp}&page=${page}&type=1`)

export const reqDefaultMsg = () => request.get('defaultMessage')

export const reqMsg = (nppMsg, pageMsg) =>
  request.get(`serviceComfirmedMessage/?npp=${nppMsg}&page=${pageMsg}`)

export const reqDriverStatusList = (id) =>
  request.get(`status/driverlist/?orderid=${id}`)

// post
export const reqCancelOrder = (cancelInfo) =>
  request.post(`service/callcar/cancel`, cancelInfo)

// put
export const reqDriverAbnormal = (id) =>
  request.put(`updatedriverabnormal?id=${id}`)

export const reqDriverCancel = (orderIdObj) =>
  request.put(`service/driver/cancel`, orderIdObj)

export const reqUpdateAbnormalMsg = (abnormalId) =>
  request.put(
    `updatedriverabnormal/?id=${abnormalId}&task=update_message_status`,
  )

export const reqAbnormalSolve = (abnormalId) =>
  request.put(
    `updatedriverabnormal/?id=${abnormalId}&task=update_message_solve`,
  )

export const reqUpdateReserve = (reservation) =>
  request.put('reservation/updatePassenger', reservation)



// WEBPACK FOOTER //
// ./src/api/hailState/index.js